import classnames from 'classnames';
import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import categoryIcon from 'uikit/Icons/Categories';
import routes from 'utils/routeTranslator';

import { AllCategories$TopCategory } from '../AllCategories.helpers';
import './AllCategoriesSection.scss';

type AllCategoriesSection$Props = AllCategories$TopCategory & {
  citySlug?: string;
  onClick: () => void;
};

const AllCategoriesSection: FC<AllCategoriesSection$Props> = (props) => {
  const getGroupClassName = (groupsCount: number) =>
    classnames('allCategoriesSection__group', {
      'allCategoriesSection__group_shouldWrap': groupsCount === 1,
    });

  return (
    <div className="allCategoriesSection" id={props.slug}>
      <div className="allCategoriesSection__header">
        <div className="allCategoriesSection__icon">{categoryIcon(props.slug)}</div>
        <h2 className="allCategoriesSection__title">{props.name}</h2>
      </div>

      <div className="allCategoriesSection__childCategories">
        {props.l4Groups.map((categoryGroup, i, arr) => (
          <div className={getGroupClassName(arr.length)} key={`allCategoriesSection__group_${categoryGroup.name}`}>
            {categoryGroup.name !== 'default' && (
              <p className="allCategoriesSection__groupTitle">{categoryGroup.name}</p>
            )}
            <ul className="allCategoriesSection__groupList">
              {categoryGroup.l4Categories.map((category) => (
                <li
                  className="allCategoriesSection__groupItem"
                  key={`allCategoriesSection__groupItem_${category.slug}`}
                >
                  <Link
                    to={routes.get('front::category', {
                      slug: category.slug,
                      city: props.citySlug,
                    })}
                    onClick={props.onClick}
                  >
                    {category.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AllCategoriesSection;
